import {
  getIsRemovingUserFromGroupChannelLoading,
  getRemovingUserFromSelectedGroupChannelDefaultErrorMessage,
} from 'gcs-common/slices/administration/administrationChannels/administrationChannelsSelectors';
import { resetRemovingUserFromSelectedGroupChannelDefaultErrorMessage } from 'gcs-common/slices/administration/administrationChannels/administrationChannelsSlice';
import {
  fetchSelectedAdministrationChannel,
  removeUserFromGroupChannel,
} from 'gcs-common/slices/administration/administrationChannels/administrationChannelsThunks';
import PropTypes from 'prop-types';
import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { showFailureNotification } from '../../../../slices/notifications/ShowNotificationThunk';
import Button from '../../../Button/Button';
import styles from './styles.module.scss';

const GroupChannelMemberDelete = ({ user, channelId, channelName, onCancel, onSuccess }) => {
  const isDeleting = useSelector(getIsRemovingUserFromGroupChannelLoading);
  const dispatch = useDispatch();
  const defaultErrorMessage = useSelector(getRemovingUserFromSelectedGroupChannelDefaultErrorMessage);

  useEffect(() => {
    if (defaultErrorMessage) {
      dispatch(
        showFailureNotification(
          defaultErrorMessage,
          dispatch(resetRemovingUserFromSelectedGroupChannelDefaultErrorMessage()),
        ),
      );
    }
  }, [defaultErrorMessage, dispatch]);

  useEffect(() => {
    dispatch(resetRemovingUserFromSelectedGroupChannelDefaultErrorMessage());
  }, [dispatch]);

  const handleDelete = useCallback(async () => {
    const result = await dispatch(removeUserFromGroupChannel({ channelId, memberId: user.id }));
    if (!result.error) {
      onSuccess();
      await dispatch(fetchSelectedAdministrationChannel({ channelId }));
    }
  }, [user, channelId, dispatch, onSuccess]);

  return (
    <div className={styles.column}>
      Möchten Sie von den Nutzer
      {' "'}
      {user.name}
      {'" '}
      wirklich aus dem Channel
      {' "'}
      {channelName}
      {'" '}
      entfernen?
      <div className={styles.buttonRow}>
        <Button className={styles.modalButtonSecondary} type="button" disabled={isDeleting} onClick={onCancel}>
          Abbrechen
        </Button>
        <Button className={styles.modalButton} type="button" onClick={handleDelete} disabled={isDeleting}>
          Löschen
        </Button>
      </div>
    </div>
  );
};

GroupChannelMemberDelete.propTypes = {
  user: PropTypes.object.isRequired,
  channelId: PropTypes.string.isRequired,
  channelName: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
};

export default GroupChannelMemberDelete;
